module.exports = "/images/star.svg?9b2f787a23341f55d638440875bfddeb";